module.exports = __webpack_public_path__ + "static/img/pic.301623f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic.jpg
// module id = /9BQ
// module chunks = 1